module.exports = __webpack_public_path__ + "img/e2853a9.png";